/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { userToProps } from '../../../actions/users';
import { getCalculateCBGU, getCalculateCBGUSuccess } from '../../../actions/calculateCbgu';
import { setCalloriesNorm } from '../../../actions/setParams';
import { updateUserData } from '../../../actions/updateUserData';
import {
  Wrapper,
  SpinnerContainer,
  Spinner,
  NoUserSelected,
  UserDetailBlockWrap,
  GoalsBlock,
  UserDatah1,
  ParametersBlock,
  WrapSaveBlock,
  ValidateUserDataGeneralMessage,
  Button,
} from './StyleUserDetailBlock';
import RenderInputUserData from './RenderInputUserData';
import RenderSelectUserData from './RenderSelectUserData';
import RenderTextUserData from './RenderTextUserData';
import get from '../../../utils/get-value';

const sex = [
  { id: 2, value: 'Мужской' },
  { id: 3, value: 'Женский' },
];

const activity = [
  { id: 1, value: 'Низкая или отсутствует', coefficient: 1.2 },
  { id: 2, value: 'Невысокая активность (1-3 тренировки в неделю)', coefficient: 1.375 },
  { id: 3, value: 'Умеренная активность (4-5 тренировок в неделю)', coefficient: 1.55 },
  { id: 4, value: 'Высокая активность (6-7 тренировок в неделю)', coefficient: 1.725 },
  {
    id: 5,
    value: 'Экстремально высокая активность (2 и более тренировок в день)',
    coefficient: 1.9,
  },
];

class UserDetailBlock extends Component {
  state = {
    showButtonSaveUserDetailBlock: false,
  };

  calculateBGU = (receivedCbgu) => {
    const { cbgucalories, cbgu, getCalculateCBGUSuccess } = this.props;
    if (receivedCbgu.calories !== cbgucalories && cbgucalories !== '') {
      const coef = receivedCbgu.calories / cbgucalories;
      receivedCbgu.fats = Math.round(cbgu.fats * coef * 10) / 10;
      receivedCbgu.carbohydrates = Math.round(cbgu.carbohydrates * coef * 10) / 10;
      receivedCbgu.proteins = Math.round(cbgu.proteins * coef * 10) / 10;
    }
    const cbguObjectForSetLocal = {
      0: { calories: receivedCbgu.calories },
      carbohydrates: receivedCbgu.carbohydrates,
      fats: receivedCbgu.fats,
      proteins: receivedCbgu.proteins,
    };
    getCalculateCBGUSuccess(cbguObjectForSetLocal);
  };

  handleEditUserParamsInput = (e) => {
    const { user, userToProps } = this.props;
    const userData = JSON.parse(JSON.stringify(user));
    const inputData = e.target.value;
    switch (e.target.name) {
      case 'gender': {
        const genderData = sex.find((elem) => elem.id === +inputData);
        userData.params.gender.id = genderData.id;
        userData.params.gender.gender = genderData.value;
        userData.params.gender_id = genderData.id;
        break;
      }
      case 'goal': {
        userData.goals = inputData;
        break;
      }
      case 'activity': {
        const activityId = +inputData;
        const foundedActivityData = activity.find((activityData) => activityData.id === activityId);
        foundedActivityData.name = foundedActivityData.value;
        userData.params.activity = foundedActivityData;
        userData.params.activity_id = activityId;
        break;
      }
      default: {
        userData.params[e.target.name] = inputData;
      }
    }
    userToProps(userData);
  };

  handleSubmitUserDetailForm = (e) => {
    e.preventDefault();
    const {
      user: {
        params: { age, weight, height, activity_id },
      },
    } = this.props;
    const { updateUserData, getCalculateCBGU, user } = this.props;
    if (
      +weight >= 40 &&
      +weight <= 300 &&
      +height >= 100 &&
      +height <= 250 &&
      +age >= 18 &&
      +age <= 90
    ) {
      const genderValueFromSelect = +e.target.gender.value; // getting data from input because it can be by default female
      const checkUserGender = genderValueFromSelect !== 1 ? genderValueFromSelect : 3; // set default female gende
      user.params.gender_id = checkUserGender;
      updateUserData(user);
      getCalculateCBGU({
        age,
        weight,
        height,
        activity_id,
        gender_id: checkUserGender,
      });
      this.setState({ showButtonSaveUserDetailBlock: false });
    }
  };

  handleEditСaloriesInput = (e) => {
    const { value } = e.target;
    const {
      cbgu: { fats, carbohydrates, proteins },
      setCalloriesNorm,
    } = this.props;
    if (!!+value || value === '0') {
      const cbgu = { calories: +value, fats, carbohydrates, proteins };
      this.calculateBGU(cbgu);
      setCalloriesNorm(value);
    }
  };

  handleValidateChandeInput = (e) => {
    const { value } = e.target;
    const inputValue = value < 0 ? Math.abs(value) : value;
    if (inputValue.charAt(0) === '0' || inputValue.charAt(0) === '') return (e.target.value = 1);
    if (inputValue > 10000) return (e.target.value = 9999);
    e.target.value = inputValue;
  };

  handleOnFocusInput = () => {
    this.setState({ showButtonSaveUserDetailBlock: true });
  };

  renderUserDataElements = (data) => {
    return data.map((elem) => elem.renderFunc(elem));
  };

  render() {
    const { showButtonSaveUserDetailBlock } = this.state;
    const {
      cbgucalories = 0,
      cbgu: { proteins = 0, fats = 0, carbohydrates = 0 },
      user: { params, goals },
      isUserDataLoading,
      userIndex,
      cbgu,
      user,
    } = this.props;
    const weight = +get(params, 'weight');
    const height = +get(params, 'height');
    const age = +get(params, 'age');
    const gender_id = +get(params, 'gender_id');
    const activity_id = +get(params, 'activity_id');
    const isValidUserData =
      weight >= 40 && weight <= 300 && height >= 100 && height <= 250 && age >= 18 && age <= 90;
    const ParametersBlockRenderData = [
      {
        title: 'Пол:',
        name: 'gender',
        renderFunc: RenderSelectUserData,
        changeFunc: this.handleEditUserParamsInput,
        focusFunc: this.handleOnFocusInput,
        units: '',
        validateErrorMessage: 'Пол не определен. По умолчанию был установлен женский.',
        value: gender_id !== 1 ? gender_id : 3, // set default female gender
        optionsForSelect: sex,
        isValidate: gender_id !== 1,
      },
      {
        title: 'Возраст:',
        name: 'age',
        renderFunc: RenderInputUserData,
        isEdit: true,
        changeFunc: this.handleEditUserParamsInput,
        focusFunc: this.handleOnFocusInput,
        units: '',
        validateErrorMessage: 'Возраст должен быть больше 18 и меньше 90',
        value: age || '',
        isValidate: age >= 18 && age <= 90,
      },
      {
        title: 'Вес:',
        name: 'weight',
        renderFunc: RenderInputUserData,
        isEdit: true,
        changeFunc: this.handleEditUserParamsInput,
        focusFunc: this.handleOnFocusInput,
        units: 'кг',
        validateErrorMessage: 'Вес дожен быть больше 40 и меньше 300',
        value: weight || '',
        isValidate: weight >= 40 && weight <= 300,
      },
      {
        title: 'Рост:',
        name: 'height',
        renderFunc: RenderInputUserData,
        isEdit: true,
        changeFunc: this.handleEditUserParamsInput,
        focusFunc: this.handleOnFocusInput,
        units: 'см',
        validateErrorMessage: 'Рост должен быть больше 100 и меньше 250',
        value: height || '',
        isValidate: height >= 100 && height <= 250,
      },
      {
        title: 'Активность:',
        name: 'activity',
        renderFunc: RenderSelectUserData,
        changeFunc: this.handleEditUserParamsInput,
        focusFunc: this.handleOnFocusInput,
        units: '',
        value: activity_id || 0,
        optionsForSelect: activity,
      },
    ];

    const KBGURenderData = [
      {
        title: 'К:',
        name: 'calories',
        renderFunc: showButtonSaveUserDetailBlock ? RenderTextUserData : RenderInputUserData,
        maxValue: '10000',
        minValue: '1',
        validateChangeFunc: this.handleValidateChandeInput,
        changeFunc: this.handleEditСaloriesInput,
        units: '',
        validateErrorMessage: '',
        value: isValidUserData ? (cbgucalories * 0.9).toFixed() : 0,
      },
      {
        title: 'Б: ',
        name: '',
        renderFunc: RenderTextUserData,
        units: '',
        validateErrorMessage: '',
        value: isValidUserData ? proteins : 0,
      },
      {
        title: 'Ж:',
        name: '',
        renderFunc: RenderTextUserData,
        units: '',
        validateErrorMessage: '',
        value: isValidUserData ? fats : 0,
      },
      {
        title: 'У: ',
        name: '',
        renderFunc: RenderTextUserData,
        units: '',
        validateErrorMessage: '',
        value: isValidUserData ? carbohydrates : 0,
      },
    ];

    const GoalsRenderData = [
      {
        title: 'Вес: ',
        name: 'goal',
        renderFunc: RenderInputUserData,
        changeFunc: this.handleEditUserParamsInput,
        focusFunc: this.handleOnFocusInput,
        units: 'кг',
        validateErrorMessage: '',
        value: goals || 0,
      },
    ];

    if (isUserDataLoading) {
      return (
        <Wrapper>
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        </Wrapper>
      );
    }

    if (!userIndex) {
      return (
        <Wrapper>
          <NoUserSelected>Пользователь не выбран</NoUserSelected>
        </Wrapper>
      );
    }

    if (userIndex !== null && cbgu !== undefined && user.params) {
      return (
        <Wrapper onSubmit={this.handleSubmitUserDetailForm}>
          <UserDetailBlockWrap>
            <ParametersBlock>
              <UserDatah1>Параметры</UserDatah1>
              {this.renderUserDataElements(ParametersBlockRenderData)}
            </ParametersBlock>
            <GoalsBlock>
              <UserDatah1>Цели</UserDatah1>
              {this.renderUserDataElements(GoalsRenderData)}
              <UserDatah1>Дневная норма</UserDatah1>
              <DayNormInfo>* в т.ч. -10% на похудение </DayNormInfo>
              {this.renderUserDataElements(KBGURenderData)}
            </GoalsBlock>
          </UserDetailBlockWrap>
          <ValidateUserDataGeneralMessage>
            {!isValidUserData &&
              'Для подсчета КБЖУ и изменения данных пользователя заполните поля допустимыми значениями'}
          </ValidateUserDataGeneralMessage>
          {showButtonSaveUserDetailBlock && (
            <WrapSaveBlock>
              <Button type="submit">Сохранить</Button>
            </WrapSaveBlock>
          )}
        </Wrapper>
      );
    }
  }
}

const mapStateToProps = (state) => {
  const { users, user, isUserDataLoading } = state.reducers;
  const { cbgu, cbgucalories } = state.calculateCbgu;
  return {
    users,
    cbgu,
    cbgucalories,
    user,
    isUserDataLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserData: (userData) => {
      dispatch(updateUserData(userData));
    },
    getCalculateCBGU: (data) => {
      dispatch(getCalculateCBGU(data));
    },
    setCalloriesNorm: (callories) => {
      dispatch(setCalloriesNorm(callories));
    },
    userToProps: (user) => {
      dispatch(userToProps(user));
    },
    getCalculateCBGUSuccess: (cbgu) => {
      dispatch(getCalculateCBGUSuccess(cbgu));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailBlock);

const DayNormInfo = styled.div`
  margin: -12px 25px;
  font-size: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/UserDetailBlock/UserDetailBlock.jsx